import type { MarkdownExtension } from "./parse";

const PMC_OA_S3_BASE = "https://pmc-oa-opendata.s3.amazonaws.com";

interface PmcFigureImageRef {
  pmcid: string;
  version: string;
  href: string;
}

function pmcFigureImageUrl({ pmcid, version, href }: PmcFigureImageRef): string {
  return `${PMC_OA_S3_BASE}/PMC${pmcid}.${version}/${href}`;
}

interface PmcFigureRendererProps {
  meta: Record<string, string>;
  body: string;
}

function PmcFigureRenderer({ meta, body }: PmcFigureRendererProps) {
  const { pmcid, version, href, label } = meta;
  if (!pmcid || !version || !href) return null;
  const src = pmcFigureImageUrl({ pmcid, version, href });
  return (
    <figure>
      <img src={src} alt={body} loading="lazy" />
      <figcaption>
        <b>{label}</b> {body}
      </figcaption>
    </figure>
  );
}

export const pmcFigureExtension: MarkdownExtension = {
  language: "pmc-figure",
  Component: PmcFigureRenderer,
};
